import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";

import { externalpageTypes } from "../../shared/services/externalpage.service";
import { AdminExternalpagesComponent } from "../admin-externalpages/admin-externalpages.component";

@Component({
  selector: "app-admin-blogposts",
  templateUrl: "./admin-blogposts.component.html",
  styleUrls: ["./admin-blogposts.component.scss"],
  standalone: false,
})
export class AdminBlogpostsComponent
  extends AdminExternalpagesComponent
  implements OnInit
{
  externalpageTypes = externalpageTypes;

  override configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: "Publication date",
        name: "publicationDate",
        type: "date",
      },
      {
        header_name: "Title",
        name: "title",
        type: "text",
      },
      {
        header_name: "Status",
        name: "status",
        type: "text",
      },
      {
        header_name: "Regions",
        name: "regions",
        type: "array",
      },
    ],
    endpoint: "externalpage",
    queryParams: {
      PageType: externalpageTypes.Blog,
    },
    data: <any>[],
    buttons: [
      {
        class: "btn btn-danger",
        event: "delete",
        text: "Delete",
      },
      {
        class: "btn btn-warning",
        event: "edit",
        text: "Edit",
      },
    ],
    class: "",
    reloadListener: new Subject(),
  };

  override ngOnInit(): void {}

  override handleButtonEvent($event: any) {
    super.handleButtonEvent($event);
  }
}
